import { useState } from "react";
import { Plus, User, Factory, UserPlus } from "lucide-react";

interface Props {
  role: "customer" | "supplier";
  partyList: Array<{ name: string; phone?: string; email?: string }>;
  onSelect: (item: { name: string; phone?: string; email?: string }) => void;
}

export default function LinkedPartySelector({ role, partyList, onSelect }: Props) {
  const [showNew, setShowNew] = useState(false);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");

  async function pickDeviceContact() {
    if (!('contacts' in navigator) || !('ContactsManager' in window)) {
      alert('Contact Picker is not supported on this device/browser.');
      return;
    }
    try {
      // @ts-ignore - experimental API
      const contacts = await navigator.contacts.select(['name', 'email', 'tel'], {multiple:false});
      if (contacts && contacts.length > 0) {
        const c = contacts[0];
        onSelect({
          name: (c.name && c.name[0]) || '',
          email: (c.email && c.email[0]) || '',
          phone: (c.tel && c.tel[0]) || ''
        });
      }
    } catch {
      // User cancelled
    }
  }
  return (
    <div className="my-2">
      <div className="flex gap-2 items-center mb-2">
        <span className="font-medium text-sm text-muted-foreground">{role === "customer" ? <User size={15} /> : <Factory size={15} />} {role === "customer" ? "Customer" : "Supplier"}</span>
        {!showNew && (
          <button type="button" className="text-primary text-xs px-2 py-1 rounded border border-primary ml-2 flex items-center gap-1 hover:bg-primary/10" onClick={() => setShowNew(true)}><Plus size={14}/> Add New</button>
        )}
      </div>
      {showNew ? (
        <div className="flex flex-col gap-2">
          {role === 'customer' && (
            <button
              type="button"
              className="flex items-center gap-2 text-primary text-sm mt-2 mb-1 font-medium hover:underline"
              onClick={pickDeviceContact}
              disabled={!('contacts' in navigator) || !('ContactsManager' in window)}
              title={(('contacts' in navigator) && ('ContactsManager' in window)) ? "Pick from device contacts" : "Not supported on this browser"}
            >
              <UserPlus size={16}/> Pick from Contacts
            </button>
          )}
          <input className="border rounded px-2 py-1 text-sm" placeholder={`Name of ${role}`} value={name} onChange={e => setName(e.target.value)} required />
          <input className="border rounded px-2 py-1 text-sm" placeholder="Phone (optional)" value={phone} onChange={e => setPhone(e.target.value)} />
          <input className="border rounded px-2 py-1 text-sm" placeholder="Email (optional)" value={email} onChange={e => setEmail(e.target.value)} />
          <button type="button" className="bg-primary text-primary-foreground px-3 py-1 rounded text-xs font-semibold" onClick={() => {
            if (!name.trim()) return;
            onSelect({ name: name.trim(), phone: phone.trim(), email: email.trim() }); setShowNew(false); setName(""); setPhone(""); setEmail("");
          }}>Save</button>
          <button type="button" className="text-xs text-muted-foreground underline ml-1" onClick={() => setShowNew(false)}>Cancel</button>
        </div>
      ) : (
        <select className="border rounded px-2 py-1 text-sm w-full" defaultValue="" onChange={e => {
          const idx = parseInt(e.target.value, 10);
          if (!isNaN(idx)) onSelect(partyList[idx]);
        }}>
          <option value="">Select Existing...</option>
          {partyList.map((c, i) => (
            <option key={i} value={i}>{c.name}{c.phone ? ` (${c.phone})` : ""}</option>
          ))}
        </select>
      )}
    </div>
  );
}